import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Import default banner images (you can adjust these if needed)
import Banner1 from "../../../assets/images/Banners/1000x540/Main_banner.png";
import Banner2 from "../../../assets/images/Banners/1000x540/bigmall_New_Year_Banner.png";
import Banner3 from "../../../assets/images/Banners/1000x540/Bigmall_tech_banners.png";

// Custom Next Arrow component using Bootstrap icon
function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div 
      className={className}
      style={{ 
        ...style, 
        display: "block", 
        right: "10px", 
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        opacity: 0.8,
      }}
      onClick={onClick}
    >
      <i className="bi bi-chevron-right text-dark fs-2"></i>
    </div>
  );
}

// Custom Prev Arrow component using Bootstrap icon
function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div 
      className={className}
      style={{ 
        ...style, 
        display: "block", 
        left: "10px", 
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 2,
        opacity: 0.8,
      }}
      onClick={onClick}
    >
      <i className="bi bi-chevron-left text-dark fs-2"></i>
    </div>
  );
}

const PromotionalSlider = ({ banners }) => {
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Fallback default banners if none are passed as props
  const defaultBanners = [
    {
      src: Banner1,
      alt: "Default Banner 1",
      url: "/",
    },
    {
      src: Banner2,
      alt: "Default Banner 2",
      url: "/",
    },
    {
      src: Banner3,
      alt: "Default Banner 3",
      url: "/",
    },
  ];

  const sliderBanners = banners && banners.length > 0 ? banners : defaultBanners;

  return (
    <section className="promotional-slider mt-10">
      <div className="container-fluid p-0">
        <Slider {...settings}>
          {sliderBanners.map((banner, index) => (
            <div key={index} className="px-2">
              <a href={banner.url}>
                <img
                  src={banner.src}
                  alt={banner.alt}
                  style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "540px",
                    objectFit: "cover",
                  }}
                />
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default PromotionalSlider;
